import { Component, Input } from '@angular/core';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

@Component({
  selector: 'pp-padlock-icon',
  templateUrl: './padlock-icon.component.html',
  styleUrl: './padlock-icon.component.scss',
  standalone: false,
})
export class PadlockIconComponent {
  @Input() ppIsOpen?: boolean = false;

  icon: EIconPath = EIconPath.PADLOCK_CLOSED;

  ngOnChanges() {
    this.icon = this.ppIsOpen ? EIconPath.PADLOCK_OPEN : EIconPath.PADLOCK_CLOSED;
  }
}
